import { render, staticRenderFns } from "./BuyForm.vue?vue&type=template&id=6aab98c0&scoped=true&"
import script from "./BuyForm.vue?vue&type=script&lang=js&"
export * from "./BuyForm.vue?vue&type=script&lang=js&"
import style0 from "./BuyForm.vue?vue&type=style&index=0&id=6aab98c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab98c0",
  null
  
)

export default component.exports